/* src/app/shared/components/content-loading-progress/content-loading-progress.component.scss */
ngx-skeleton-loader {
  width: 100%;
}
.loading-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto Flex",
    "Helvetica Neue",
    Arial,
    sans-serif;
}
@media screen and (min-width: 48rem) {
  .loading-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
:host(.content-loading-progress) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  position: relative;
  padding-top: 2em;
}
@media screen and (min-width: 48rem) {
  :host(.content-loading-progress) {
    padding-top: 0;
  }
}
/*# sourceMappingURL=content-loading-progress.component.css.map */
